<template>
  <div>
    <!-- Adviseurs omgeving; Gebruikers adviseur -->
    <div id="firstMenubar" class="row roundedtop menubar">
      <div class="title">Onboardings</div>
      <a
        v-if="style == 'db'"
        href="https://www.doelbeleggen.nl/agenda/atp"
        target="_blank"
        class="button"
        style="float:right;"
      >
        <awesomeIcon icon="phone-alt"/> <span class="mobile-hidden">Plan een belafspraak in</span>
      </a>
    </div>
    <div class="card inset-small marginbottom roundedBottom" v-if="role == 2">
      <h3 class="backgroundTitle">Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
      <p style="line-height: 150%">
        Hier kunt u de lopende aanvragen van uw klanten zien. U ziet hier gemakkelijk welke status
        deze aanvraag heeft en welke acties er nodig zijn ter afronding. U ontvangt van ons bericht
        zodra uw klant actie onderneemt.
        <br><br>Zodra een aanvraag is afgerond en de beleggingsportefeuille is ingericht ziet u
        deze terug onder 'Klanten'.
      </p>
    </div>
    <!-- Onboarding overview -->
    <div id="atpWindow" key="clients" class="card" v-if="!loading">
      <div class="hide-mobile roundedtop menubar">
        <button
          v-for="(group) in pages"
          :key="group.value"
          @click="currentAtpView = group.value"
          :class="{
            'fontBold' : currentAtpView == group.value
          }"
        >
          {{ group.label }}
        </button>
      </div>
      <component :is="currentAtpView" />
    </div>
    <div key="loader" class="loader" v-else />
  </div>
</template>

<script>
import concepts from './conceptIntakes';
import onboardingAccepted from './onboardingAccepted';
import onboardingHanded from './onboardingHanded';
import onboardingIntake from './onboardingIntake';
import onboardingPending from './onboardingPending';
import onboardingSigned from './onboardingSigned';

export default {
  name: 'AtpUsers',
  components: {
    concepts,
    onboardingAccepted,
    onboardingHanded,
    onboardingIntake,
    onboardingPending,
    onboardingSigned,
  },
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      conceptIntakes: [],
      clientsPending: 0,
      intakes: 0,
      intakesHanded: 0,
      intakesAccepted: 0,
      intakesSigned: 0,
      currentAtpView: 'concepts',
      loading: false,
    };
  },
  created() {
    this.getAtpCustomersGroups();
    this.getConceptIntakes();
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    userIntakes() {
      return this.$store.state.intakes;
    },
    pages() {
      return [
        {
          label: `Offertes (${this.conceptIntakes.length})`,
          value: 'concepts',
        },
        {
          label: `Verstuurde offertes (${this.clientsPending})`,
          value: 'onboardingPending',
        }, {
          label: `Onboarding (${this.intakes})`,
          value: 'onboardingIntake',
        }, {
          label: `Openen rekening (${this.intakesHanded})`,
          value: 'onboardingHanded',
        }, {
          label: `Beleggingsplan (${this.intakesAccepted})`,
          value: 'onboardingAccepted',
        }, {
          label: `Rekening (${this.intakesSigned})`,
          value: 'onboardingSigned',
        },
      ];
    },
  },
  methods: {
    removeMandate(user) {
      this.$store.state.confirm.toggle({
        text: `Let op: bij het 'Intrekken' van het mandaat wordt ook de betreffende vragenlijst
        verwijderd.<br><br> Weet u zeker dat u dit mandaat wilt intrekken?`,
        confirmText: 'Intrekken',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.removeMandate(user, (response) => {
              if (response.status === 200) {
                this.getAtpCustomersGroups();
              }
            });
          }
        },
      });
    },
    becomeUser(user, intake = null) {
      this.sdk.become(user, (response) => {
        if (response.status === 200) {
          if (intake) {
            window.location.href = `?intake=${intake}`;
          } else {
            window.location.reload();
          }
        }
      });
    },
    typeToATPGoal(data) {
      if (data.goal === 'pensioen' && data.box === '1') {
        return 'Lijfrente opbouwen/uitstellen (box 1)';
      }
      if (data.goal === 'levensonderhoud' && data.box === '1') {
        return 'Lijfrente uitkeren (box 1)';
      }
      if (data.goal === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente';
      }
      if (data.goal === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk uitstellen';
      }
      if (data.goal === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk uitkeren';
      }
      if (data.goal === 'vermogensopbouw') {
        return 'Privé beleggingsrekening';
      }
      if (data.goal === 'studiekinderen') {
        return 'Beleggingsrekening voor kinderen';
      }
      if (data.goal === 'Bedrijfsrekening') {
        return 'Zakelijke beleggingsrekening';
      }
      return data.type;
    },
    getConceptIntakes() {
      this.conceptIntakes = [];
      for (let i = 0; i < this.userIntakes.length; i += 1) {
        this.conceptIntakes.push(this.userIntakes[i]);
      }
    },
    getAtpCustomersGroups() {
      this.loading = true;
      this.sdk.getAtpCustomersGroups((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            if (response.data[i].status === 'pendingMandate') {
              this.clientsPending = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboarding') {
              this.intakes = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingHanded') {
              this.intakesHanded = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingAccepted') {
              this.intakesAccepted = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingSigned') {
              this.intakesSigned = response.data[i].totalRows;
            }
          }
          this.loading = false;
        } else {
          // Not able to retrieve atp groups
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media #{$mobile} {
#atpWindow {
    padding-top: 36px;
}
#firstMenubar {
    top: 91px !important;
}
}
.fontBold {
font-weight: 600;
}
.button.horizontal {
margin: 10px;
&:first-of-type {
    margin-left: 0;
}
&:last-of-type {
    margin-right: 0;
}
}
</style>
